import { createContext } from "react"

export type ThemeScheme = "dark" | "light"

const themeContext = createContext<ThemeScheme>("light")
export default themeContext
